import { render, staticRenderFns } from "./queryorder.vue?vue&type=template&id=b18be2da&scoped=true"
import script from "./queryorder.vue?vue&type=script&lang=js"
export * from "./queryorder.vue?vue&type=script&lang=js"
import style0 from "./queryorder.vue?vue&type=style&index=0&id=b18be2da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18be2da",
  null
  
)

export default component.exports